import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithErrorHandling } from "../baseQuery";

export const blogCategoriesApi = createApi({
  reducerPath: "blogCategoriesApi",
  baseQuery: baseQueryWithErrorHandling,
  tagTypes: ["BlogCategories"],
  refetchOnFocus: true,
  refetchOnReconnect: true,

  endpoints: (builder) => ({
    // Get All Categories
    getBlogCategories: builder.query({
      query: () => "/blog-categories",
      providesTags: (result) =>
        result?.length
          ? [
              ...result.map(({ id }) => ({
                type: "BlogCategories",
                id: Number(id),
              })),
              { type: "BlogCategories", id: "LIST" },
            ]
          : [{ type: "BlogCategories", id: "LIST" }],
    }),

    // Create Category
    createBlogCategory: builder.mutation({
      query: (data) => ({
        url: "/blog-categories",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [{ type: "BlogCategories", id: "LIST" }],
    }),

    // Update Category
    updateBlogCategory: builder.mutation({
      query: ({ id, data }) => ({
        url: `/blog-categories/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "BlogCategories", id },
        { type: "BlogCategories", id: "LIST" },
      ],
    }),

    // Delete Category
    deleteBlogCategory: builder.mutation({
      query: (id) => ({
        url: `/blog-categories/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "BlogCategories", id: "LIST" }],
    }),

    // Toggle Status
    toggleBlogCategoryStatus: builder.mutation({
      query: (id) => ({
        url: `/blog-categories/${id}/toggle`,
        method: "PATCH",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "BlogCategories", id },
        { type: "BlogCategories", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetBlogCategoriesQuery,
  useCreateBlogCategoryMutation,
  useUpdateBlogCategoryMutation,
  useDeleteBlogCategoryMutation,
  useToggleBlogCategoryStatusMutation,
} = blogCategoriesApi;
